if (!customElements.get('recently-viewed-products')) {
  
  const chevron = () => `
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 17 30" fill="none">
      <g clip-path="url(#clip0_229_2194)">
        <path d="M1.28574 30C0.956518 30 0.627687 29.8746 0.376778 29.6233C-0.12543 29.1211 -0.12543 28.3072 0.376778 27.805L13.1817 15L0.376778 2.19472C-0.12543 1.69252 -0.12543 0.878619 0.376778 0.376412C0.878986 -0.125796 1.69288 -0.125796 2.19509 0.376412L15.9094 14.0907C16.1505 14.3319 16.2861 14.6587 16.2861 14.9997C16.2861 15.3406 16.1505 15.6678 15.9094 15.9086L2.19509 29.6229C1.94379 29.8746 1.61496 30 1.28574 30Z" fill="currentColor"/>
      </g>
      <defs>
      <clipPath id="clip0_229_2194">
        <rect width="16.2857" height="30" fill="white"/>
      </clipPath>
      </defs>
    </svg>
  `;
  
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
        super();
        this.product = this.dataset.product ? JSON.parse(this.dataset.product) : null;
        this.recentlyViewed = null;
    }

    connectedCallback() {
        this.updateLocalStorage();

        if (!this.recentlyViewed) { return; }

        this.populateRecentlyViewed();
        [...this.querySelectorAll('img')].forEach(img => {
          img.addEventListener('error', () => {
            img.closest('swiper-slide')?.remove();
          });
        });
    }

    async populateRecentlyViewed() {
      let productsMarkup = '';
      for (let i = 0; i < Object.keys(this.recentlyViewed)?.length; i++) {
        const productId = Object.keys(this.recentlyViewed)[i];
        if (i > 12) break;
        
        if (productId !== this?.product?.id) {
          const thisProduct = this.recentlyViewed[productId];
          await fetch(`/products/${thisProduct.handle}.json`)
          .then((response) => {
            if (!response.ok) return;
            return response.json();
          })
          .then((data) => {
            const product = data?.product;
            if (!product) return;
            const tags = product.tags.split(',').map(item=>item.trim())
            const bannedtags = ['base_product', 'hide_product']

            if (!bannedtags.some(i => tags.includes(i))) {
              productsMarkup += `
                <swiper-slide class="h-auto min-w-[calc(100%/4)] w-[calc(100%/3.5)]">
                  <intersection-loader 
                    data-url="/products/${product.handle}" 
                    data-section-id="product-tile"
                    data-preserve-classes="true"
                    class="h-full"
                  ><div class="block bg-pampas rounded-xl h-full z-0 relative">
                    <div class="loader flex items-center justify-center">
                      <span class="block w-12 h-12">
                        <svg class="animate-spin -ml-1 mr-3 h-full w-full text-accent1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      </span>
                    </div>
                  </div>
                  </intersection-loader>
                </swiper-slide>
              `;
            };
          })
          .catch((err) => console.error(`Recently Viewed Products Module: ${err}`));
        }
      }
      if (productsMarkup) {
        this.closest('.section-inner').classList.remove('hidden');
      }
        
        
      this.innerHTML = `
          <a href="#pc-end-of-carousel-rv-${this.productId}" class="skip-carousel button primary button-md inline-block absolute left-[-10000px] top-auto w-[1px] h-[1px] overflow-hidden focus:static focus:w-max focus:h-auto">Skip carousel</a>
          <swiper-container
            class="w-full flex gap-2"
            space-between="16"
            scrollbar="true"
            scrollbar-el="#scroll-bar-recent"
            slides-per-view="1.25"
            breakpoints='{"1024":{"slidesPerView":3.5,"space-between":8}}'
            inject-styles='[":host .swiper {overflow: visible}", ":host .swiper-wrapper {display: flex; align-items: stretch;}"]' 
            navigation="true"
            navigation-prev-el="#prev-recent"
            navigation-next-el="#next-recent"
            free-mode="true"
            mousewheel-control="true"
            mousewheel-force-to-axis="true"
          >
            ${productsMarkup}
          </swiper-container>
      `;
    }

    updateLocalStorage() {
      this.recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts'));

      if ((this.recentlyViewed?.[this?.product?.id]) || !this.product) return;
      localStorage.setItem('recentlyViewedProducts', `${JSON.stringify({...this.recentlyViewed, [this?.product?.id]: {...this.product} })}`);
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}